import { Component, OnInit } from "@angular/core";
import { VisibilityProvider } from "../../../shared/providers/visibility.provider";
import { ActivatedRoute, Router } from "@angular/router";
import { AdminDataProvider } from "../../../shared/providers/master-provider/admin-data.provider";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ChannelModel } from "src/app/hubadmin/shared/models/channel";
import { RegionModel } from "src/app/hubadmin/shared/models/region";
import { StateModel } from "src/app/hubadmin/shared/models/state";
import {
  PosmAuditConfigurationModel,
  PosmAudityTypesModel,
  VisibilityModel,
} from "src/app/hubadmin/shared/models/visibility";
import { ChannelProvider } from "src/app/hubadmin/shared/providers/channel.provider";
import { RegionProvider } from "src/app/hubadmin/shared/providers/region.provider";
import { StateProvider } from "src/app/hubadmin/shared/providers/state.provider";
import { ApiConfiguration } from "src/app/services/http/api-configuration";
import { ApiService } from "src/app/services/http/api.service";
import { ToastClientService } from "src/app/services/toast/toast-client.service";
import { AlertService } from "src/app/shared/providers/AlertProvider";

@Component({
  selector: "app-cooler-config-list",
  templateUrl: "./cooler-config-list.component.html",
  styleUrls: ["./cooler-config-list.component.scss"],
})
export class CoolerConfigListComponent implements OnInit {
  channels: ChannelModel[];
  filteredDetails: any = {
    search_string: "",
    regions: [],
    states: [],
    channels: [],
    posm_types: [],
    posm_elements: [],
  };

  filteredDetailsAPI: any = {
    search_string: "",
    regions: [],
    states: [],
    channels: [],
    posm_types: [],
    posm_elements: [],
  };
  getPaginationCount: number;
  pageNumber: number = 1;
  posmAuditConfigs: PosmAuditConfigurationModel[];
  states: StateModel[];
  regions: RegionModel[];
  StatesfilterByRegion: StateModel[];
  posmElements: VisibilityModel[];
  posmElementsFilterByType: VisibilityModel[];
  posmType: any[];
  constructor(
    public apiService: ApiService,
    public apiConfig: ApiConfiguration,
    public toast: ToastClientService,
    public activatedRoute: ActivatedRoute,
    public adminDataProvider: AdminDataProvider,
    public channelProvider: ChannelProvider,
    public stateProvider: StateProvider,
    public regionProvider: RegionProvider,
    public visiblityProvider: VisibilityProvider,
    private router: Router,
    public alertService: AlertService
  ) {
    this.posmType = [
      { id: 1, name: "Branding" },
      { id: 2, name: "Cooler" },
    ];
  }

  ngAfterViewInit() {
    (document.querySelector('.tabSaveBtn') as HTMLElement).style.display = 'none';
  }

  ngOnInit() {
    this.getposmAuditConfigs();
  }

  getposmAuditConfigs() {
    this.apiService
      .getHeaders(
        this.apiConfig.getVisibilityConfig +
        "?page=" +
        this.pageNumber +
        "&posm_element_config_id=" +
        this.filteredDetailsAPI.posm_elements +
        "&channel_id=" +
        this.filteredDetailsAPI.channels +
        "&state_code=" +
        this.filteredDetailsAPI.states +
        "&region_id=" +
        this.filteredDetailsAPI.regions +
        "&posm_type=" +
        2 +
        "&search_string=" +
        this.filteredDetailsAPI.search_string
      )
      .subscribe(
        (res: any) => {
          this.posmAuditConfigs = res.body
            .data as PosmAuditConfigurationModel[];
          this.getPaginationCount = res.headers.get("X-Pagination-Total-Count");
          if (this.posmAuditConfigs.length > 0) {
            this.posmAuditConfigs.forEach((item) => {
              if (item.status == 1) {
                item.statusString = "Active";
              } else {
                item.statusString = "Inactive";
              }
              if (item.channel_id == 0) {
                item.channel_name = "All";
              }
              item.show = false;
              item.statusString = (item.status == 1) ? "Active" : "Inactive";
              if (new Date(item.start_date) >= new Date()) {
                item.show = true;
              }
            });
          }
        },
        (err) => {
          console.log(err);
        }
      );
  }

  ngDoCheck() {
    this.channels = this.channelProvider.channels;
    this.states = this.stateProvider.state;
    this.regions = this.regionProvider.regions;
    this.posmElements = this.visiblityProvider.visibility;
    if (typeof this.posmElements != "undefined") {
      if (this.posmElements.length > 0) {
        this.posmElements = this.posmElements.filter(i => i.element_type == 2)
      }
    }
  }

  /* Fillter section start */
  async selectedItem(data, serviceId) {
    switch (serviceId) {
      case 1: // roles
        this.filteredDetails.regions = await data;
        this.StatesfilterByRegion = [];
        let item = data;
        item.forEach((element) => {
          this.StatesfilterByRegion.push(
            ...this.states.filter(
              (s) => s.region_id == element.id && s.state_year == 2021
            )
          );
        });
        break;
      case 2: // State
        this.filteredDetails.states = await data;
        break;
      case 3: // geography
        this.filteredDetails.channels = await data;
        break;
      case 4: // geography
        this.filteredDetails.posm_types = await data;
        this.posmElementsFilterByType = [];
        break;
      case 5:
        this.filteredDetails.posm_elements = await data;
      default:
        break;
    }
  }

  paginationClick(item) {
    this.pageNumber = item;
    this.getposmAuditConfigs();
  }

  filterListOfRecords() {
    try {
      this.filteredDetailsAPI.states = this.filteredDetails.states
        .map((i) => i.id)
        .join(",")
        .toString();
      this.filteredDetailsAPI.regions = this.filteredDetails.regions
        .map((i) => i.id)
        .join(",")
        .toString();
      this.filteredDetailsAPI.posm_types = this.filteredDetails.posm_types
        .map((i) => i.id)
        .join(",")
        .toString();
      this.filteredDetailsAPI.posm_elements = this.filteredDetails.posm_elements
        .map((i) => i.id)
        .join(",")
        .toString();
      this.filteredDetailsAPI.channels = this.filteredDetails.channels
        .map((i) => i.id)
        .join(",")
        .toString();
      this.filteredDetailsAPI.search_string = this.filteredDetails.search_string;
      this.getposmAuditConfigs();
    } catch (error) { }
  }

  changeStatus(item: PosmAudityTypesModel) {
    item.status = item.status == false ? 0 : 1;
    this.apiService
      .put(this.apiConfig.updateVisibilityConfig + "?id=" + item.id, item)
      .subscribe((res: any) => {
        this.alertService.success(res.data.message);
        this.clearSuccess();
        this.getposmAuditConfigs();
      });
  }

  editTemplate(item: PosmAudityTypesModel) {
    this.router.navigate(["/", "hubAdmin", "cooler-config-add", item.id]);
  }

  redirectToAddAndEdit() {
    this.router.navigate(["/", "hubAdmin", "cooler-config-add", ""]);
  }

  clearSuccess() {
    setTimeout(() => {
      this.alertService.clear(); // stop foreground spinner of the master loader with 'default' taskId
    }, 4000);
  }
}
